import { render, staticRenderFns } from "./ViewLandTitle.vue?vue&type=template&id=364e2242&scoped=true&"
import script from "./ViewLandTitle.vue?vue&type=script&lang=js&"
export * from "./ViewLandTitle.vue?vue&type=script&lang=js&"
import style0 from "./ViewLandTitle.vue?vue&type=style&index=0&id=364e2242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e2242",
  null
  
)

export default component.exports